import { IPublishTermsService } from '../../types';
import { mergeId } from '../mergeId';
import { mergePlacingType } from './mergePlacingType';

export function mergeService(
  prevService: IPublishTermsService,
  nextService: IPublishTermsService,
): IPublishTermsService {
  const { publishOptions: prevPublishOptions } = prevService;
  const { publishOptions: nextPublishOptions } = nextService;

  const selectedPackageId = mergeId(
    prevPublishOptions.selectedPackageId,
    nextPublishOptions.selectedPackageId,
    nextPublishOptions.packageIds,
  );

  const selectedPeriodId = mergeId(
    prevPublishOptions.selectedPeriodId,
    nextPublishOptions.selectedPeriodId,
    nextPublishOptions.periodIds,
  );

  const selectedRecommendedPackageId = mergeId(
    prevPublishOptions.selectedRecommendedPackageId,
    nextPublishOptions.selectedRecommendedPackageId,
    nextPublishOptions.recommendedPackageIds,
  );

  const selectedPlacingType = mergePlacingType(
    prevPublishOptions.selectedPlacingType,
    nextPublishOptions.selectedPlacingType,
    nextPublishOptions.packageIds,
    nextPublishOptions.periodIds,
  );

  return {
    ...nextService,
    publishOptions: {
      ...nextPublishOptions,
      selectedPackageId,
      selectedPeriodId,
      selectedRecommendedPackageId,
      selectedPlacingType,
    },
  };
}
